import gql from 'graphql-tag'

export const fetchBanner = banner_id => {
	return {
		query: gql`
			query ($banner_id: bigint!) {
				banner: banners_by_pk(id: $banner_id) {
					name: banner_name
					order
					publishing_date
					country_id
					roles: banners_roles {
						id: rol_id
					}
					image {
						file_name
						mime
						url
						id
					}
				}
			}
		`,
		variables: { banner_id }
	}
}
